import { TASK_MODEL } from 'services/entity/task';
import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const GenericColumns = [
  ARCHIVED_COLUMN,
  {
    headerName: TASK_MODEL.taskName.label,
    field: 'multiTaskName',
    width: LIST_WIDTH.md,
  },
  {
    headerName: TASK_MODEL.taskSite.label,
    field: TASK_MODEL.taskSite.id,
    width: LIST_WIDTH.xl,
  },
  {
    headerName: TASK_MODEL.taskType.label,
    field: TASK_MODEL.taskType.id,
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: TASK_MODEL.status.label,
    field: TASK_MODEL.status.id,
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: TASK_MODEL.taskCategory.label,
    field: TASK_MODEL.taskCategory.id,
    width: LIST_WIDTH.OBJECT_NAME,
    cellRenderer: 'iconComponent', // this cell renderer can be used to render icons from the api
  },
  {
    headerName: TASK_MODEL.assigneeFullName.label,
    field: TASK_MODEL.assigneeFullName.field,
    width: LIST_WIDTH.STATUS,
  },

  {
    headerName: TASK_MODEL.schedule.startAfter.label,
    field: TASK_MODEL.schedule.startAfter.id,
    width: LIST_WIDTH.sm,
  },
  {
    headerName: TASK_MODEL.schedule.finishBefore.label,
    field: TASK_MODEL.schedule.finishBefore.id,
    width: LIST_WIDTH.sm,
  },
  {
    headerName: TASK_MODEL.expectedDuration.label,
    field: TASK_MODEL.expectedDuration.id,
    width: LIST_WIDTH.md,
  },
  {
    headerName: TASK_MODEL.startedByName.label,
    field: TASK_MODEL.startedByName.id,
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: TASK_MODEL.finishedByName.label,
    field: TASK_MODEL.finishedByName.id,
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: TASK_MODEL.timeStarted.label,
    field: TASK_MODEL.timeStarted.id,
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: TASK_MODEL.timeEnded.label,
    field: TASK_MODEL.timeEnded.id,
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];
